module.exports = __webpack_public_path__ + "img/50.6e6da658.svg";